import { minNoiseFloorRms, noiseFloorWindowMs, voicingClarityMin, voicingFloorDb } from './constants.js'
import { median } from './statistics.js'
import type { PitchFrame } from './types.js'

export interface VoicingOptions {
  clarityMin?: number
  floorDb?: number
  floorWindowMs?: number
}

/**
 * The measured noise floor: the median RMS of the head of the capture window, floored so a
 * digitally silent lead-in cannot make every later frame pass by dividing by nothing.
 */
export const noiseFloorRms = (frames: PitchFrame[], floorWindowMs = noiseFloorWindowMs) => {
  const leadIn = frames.filter(frame => frame.time < floorWindowMs / 1000)
  return Math.max(median(leadIn.map(frame => frame.rms)), minNoiseFloorRms)
}

/**
 * The voicing gate (§5.1): a frame counts as sung when it is clear enough to be periodic *and*
 * loud enough to be the user. Two conditions, because they catch different things — clarity
 * rejects loud aperiodic noise, the floor rejects quiet periodic material that is not the user.
 */
export const voicedFrames = (frames: PitchFrame[], options: VoicingOptions = {}): PitchFrame[] => {
  const { clarityMin = voicingClarityMin, floorDb = voicingFloorDb, floorWindowMs = noiseFloorWindowMs } = options
  const floor = noiseFloorRms(frames, floorWindowMs)

  return frames.filter(
    frame => frame.frequency > 0 && frame.clarity >= clarityMin && 20 * Math.log10(frame.rms / floor) >= floorDb
  )
}
